let isdev = process.env.NODE_ENV === 'development';
export default {
    INDEX_DATA_URL: '//c.youdao.com/dsp/index_data.json',
    ADVANTAGE_DATA_URL: '//c.youdao.com/dsp/advantage_data.json',
    IMG_DATA_URL: '//shared.ydstatic.com/ead/dynamic/dynamic-template/image/ow_adimg1',
    FORM_URL: 'http://impservice.youdao.com/shutup/submit.s?from=XQ_2014_11',
    CMS_ADS: isdev? 'cmsApi': '//c.youdao.com'
}


// WEBPACK FOOTER //
// ./src/util/constant.js